// extracted by mini-css-extract-plugin
export default {"video-info":"VmNnkKPL8t2rTM7OBpYQ"};